import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import {
    useCategoryContext,
    useSubCategory
} from "@/components/Navigation/FlyoutMenu/components/category/context/category.context";

type Props = {
    className?: string;
    children?: ReactNode;
};

export const Link = ({ className, children }: Props) => {
    const { onMouseEnter, onMouseLeave } = useCategoryContext();
    const { index: subCategoryIndex } = useMapped();
    const { category } = useSubCategory(subCategoryIndex);

    if (!category) return null;

    const handleOnMouseEnter = () => {
        onMouseEnter(subCategoryIndex);
    };

    const handleOnMouseLeave = () => {
        onMouseLeave();
    };

    return (
        <li
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
        >
            <Anchor
                color={"link"}
                fullWidth={true}
                className={cn(className)}
                href={category.url}
            >
                {category.title}
                {children}
            </Anchor>
        </li>
    );
};
